import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  verifyTag: [],
  getAllVerifyTag: []
};

export const VerifyTagSlice = createSlice({
  name: "verifyTag",
  initialState,
  reducers: {
    getVerifyTagAction: (state, action) => {
      state.verifyTag = action.payload;
    },
  },
});

export default VerifyTagSlice.reducer;

export const { getVerifyTagAction } = VerifyTagSlice.actions;
